import "./main.css";

// ActiveStorage Direct Upload
import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();

// Turbo
import * as Turbo from "@hotwired/turbo";
Turbo.start();

// Turbo Power
import TurboPower from "turbo_power";
TurboPower.initialize(Turbo.StreamActions);

// Enable View Transitions API
Turbo.config.drive.progressBarDelay = 100;

// ActionCable + Turbo Streams over WebSocket
// Bridges turbo-rails gem's turbo_stream_from helper with Vite
import "../channels/turbo_cable";

// Rhino Editor (Action Text WYSIWYG — replaces Trix)
import "rhino-editor";
import "rhino-editor/exports/styles/trix.css";

// Stimulus
import "../controllers";

// Turbo Mount (React components within Hotwire)
import "../turbo-mount";
